import { jsxs as b, jsx as l } from "react/jsx-runtime";
import * as m from "@radix-ui/react-toast";
import { forwardRef as h, useSyncExternalStore as T, useState as x, useEffect as S } from "react";
import { T as g } from "./Toast-DgN3m1Qm.js";
function w() {
  let e = Object.freeze([]);
  const o = /* @__PURE__ */ new Set();
  let s = 0;
  function a() {
    for (const t of o) t(e);
  }
  return {
    subscribe(t) {
      return o.add(t), () => {
        o.delete(t);
      };
    },
    getSnapshot() {
      return e;
    },
    push(t) {
      s += 1;
      const n = t.id ?? `t-${s}-${Date.now().toString(36)}`, u = e.find((c) => c.id === n), p = { ...t, id: n };
      return e = Object.freeze(
        u ? e.map((c) => c.id === n ? p : c) : [...e, p]
      ), a(), n;
    },
    dismiss(t) {
      t == null ? e = Object.freeze([]) : e = Object.freeze(e.filter((n) => n.id !== t)), a();
    },
    update(t, n) {
      e = Object.freeze(e.map((u) => u.id === t ? { ...u, ...n } : u)), a();
    }
  };
}
const i = w();
function O(e) {
  return i.push(e);
}
function d(e) {
  return (o) => i.push({ ...o, tone: e });
}
const r = O;
r.success = d("success");
r.error = d("error");
r.warning = d("warning");
r.info = d("info");
r.loading = d("loading");
r.neutral = d("neutral");
r.dismiss = (e) => i.dismiss(e);
r.update = (e, o) => i.update(e, o);
r.promise = function(o, s) {
  const a = i.push({ ...s.loading, tone: s.loading.tone ?? "loading" });
  return o.then(
    (t) => {
      const n = typeof s.success == "function" ? s.success(t) : s.success;
      return i.update(a, { ...n, tone: n.tone ?? "success" }), t;
    },
    (t) => {
      const n = typeof s.error == "function" ? s.error(t) : s.error;
      throw i.update(a, { ...n, tone: n.tone ?? "error" }), t;
    }
  );
};
const R = r;
function A() {
  return r;
}
const j = {
  position: "fixed",
  bottom: "var(--space-6)",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-2)",
  padding: 0,
  margin: 0,
  listStyle: "none",
  zIndex: "var(--z-toast)",
  outline: "none",
  pointerEvents: "none"
}, D = h(function({ duration: o = 5e3, label: s, swipeDirection: a = "right", swipeThreshold: t, className: n, style: u }, p) {
  const c = T(i.subscribe, i.getSnapshot, i.getSnapshot);
  return /* @__PURE__ */ b(
    m.Provider,
    {
      duration: o,
      label: s,
      swipeDirection: a,
      swipeThreshold: t,
      children: [
        c.map((f) => /* @__PURE__ */ l(z, { entry: f }, f.id)),
        /* @__PURE__ */ l(
          m.Viewport,
          {
            ref: p,
            className: n,
            style: { ...j, ...u }
          }
        )
      ]
    }
  );
});
function z({ entry: e }) {
  const [o, s] = x(!0);
  return S(() => {
    if (!o) {
      const a = setTimeout(() => i.dismiss(e.id), 200);
      return () => clearTimeout(a);
    }
  }, [o, e.id]), /* @__PURE__ */ l(
    g,
    {
      open: o,
      onOpenChange: s,
      title: e.title,
      description: e.description,
      tone: e.tone ?? "neutral",
      action: e.action,
      icon: e.icon,
      duration: e.duration,
      dismissible: e.dismissible
    }
  );
}
export {
  D as T,
  R as t,
  A as u
};
//# sourceMappingURL=Toaster-D0q_geye.js.map
